import { useEffect } from "react";
import { track } from "../lib/plausible";

export function Journalists() {
  useEffect(() => {
    track("persona_landing_view", { persona: "journalist" });
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 space-y-10">
      <header className="space-y-3">
        <h1 className="text-3xl md:text-4xl font-semibold">
          Extract chart data from paywalled reports, in seconds — for journalists on deadline
        </h1>
        <p className="text-ink/70 text-lg">
          Paste a chart screenshot from a PDF, paywalled report, or competitor article.
          Get the underlying data as CSV. Verify visually before quoting.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">For data journalists on a deadline</h2>
        <ul className="space-y-2 text-ink/80">
          <li>· Paywalled industry-report chart → extract underlying series for your own write-up</li>
          <li>· Government dashboard screenshot → numeric data for analysis</li>
          <li>· Embargoed report PDF figure → tabular data on Friday afternoon, not Monday morning</li>
          <li>· Verification overlay re-plots extracted points on the source chart — spot misreads before you publish</li>
          <li>· Public accuracy harness at <a href="/accuracy" className="underline">/accuracy</a> — show your editor where the numbers come from</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Pricing</h2>
        <p className="text-ink/80">
          <strong>$7/mo</strong> unlimited charts, 50 MB upload limit, cancel anytime.
          14-day refund. Replaces 30 minutes of WebPlotDigitizer point-clicking per chart.
        </p>
      </section>

      <section className="space-y-3">
        <a
          href="/"
          onClick={() => track("persona_landing_cta", { persona: "journalist" })}
          className="btn-primary inline-block"
        >
          Try it free — 5 charts/day
        </a>
        <p className="text-sm text-ink/60">
          Or see the public <a href="/accuracy" className="underline">accuracy harness</a> first.
        </p>
      </section>
    </div>
  );
}
